export default __webpack_public_path__ + "static/organizations-2-b872a55d6a188f23f14851d374d2d481.jpg";